import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/api";
import { ShieldCheck } from "lucide-react";

const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({ logo: null, org_name: "DispatchMe" });

  const reload = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/settings/branding`);
      setBranding(data);
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return <BrandingContext.Provider value={{ branding, reload }}>{children}</BrandingContext.Provider>;
}

export function useBranding() {
  return useContext(BrandingContext) || { branding: { logo: null, org_name: "DispatchMe" }, reload: () => {} };
}

export function LogoMark({ size = 40, rounded = "rounded-xl" }) {
  const { branding } = useBranding();
  if (branding.logo) {
    return <img src={branding.logo} alt="logo" className={`${rounded} bg-white object-contain`} style={{ height: size, width: size }} />;
  }
  return (
    <div className={`flex items-center justify-center ${rounded} bg-blue-600`} style={{ height: size, width: size }}>
      <ShieldCheck className="text-white" style={{ height: size * 0.55, width: size * 0.55 }} />
    </div>
  );
}
